<template>
  <PlatformRenderer>
    <template v-slot:onMobile>
      <WCSpinner v-if="loading" size="xl" position="center" />
      <WCAccountSettingsMobile v-else :me="me" />
    </template>
    <template v-slot:onDesktop>
      <DashboardWindow>
        <template v-slot:title>{{ $t('accountSettings') }}</template>
        <template v-slot:body>
          <template>
            <DashboardWindowSection>
              <WCSpinner v-if="loading" size="xl" position="center" />
              <WCAccountSettings v-else :me="me" />
            </DashboardWindowSection>
          </template>
        </template>
      </DashboardWindow>
    </template>
  </PlatformRenderer>
</template>

<script>
import DashboardWindow from '@/layouts/components/Dashboard/DashboardWindow.vue';
import DashboardWindowSection from '@/layouts/components/Dashboard/DashboardWindowSection.vue';
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import axios from 'axios';
import WCAccountSettings from '@/modules/user/components/WCAccountSettings/WCAccountSettings.vue';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCAccountSettingsMobile from '../../components/WCAccountSettingsMobile/WCAccountSettingsMobile.vue';
import MeService from '../../../../services/me.service';

export default {
  name: 'AccountEdit',
  components: {
    WCAccountSettings,
    WCAccountSettingsMobile,
    PlatformRenderer,
    WCSpinner,
    DashboardWindowSection,
    DashboardWindow,
  },

  async mounted() {
    try {
      this.loading = true;
      const meResponse = await axios.get('api/me');
      this.me = meResponse.data;
      this.meService = new MeService();
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
  data() {
    return {
      meService: {},
      me: {},
      loading: false,
    };
  },
};
</script>
